// SW to CLI
export enum SWToClientMessageType {
  ERROR = "error",
  ACKNOWLEDGE = "ack",
}

type AckMessage = {
  type: SWToClientMessageType.ACKNOWLEDGE;
  ackId: string;
  ok?: boolean;
};

type ErrorMessage = {
  type: SWToClientMessageType.ERROR;
  message: string;
};

export type SWToClientMessage = AckMessage | ErrorMessage;

// CLI to SW
export enum ClientToSWMessageType {
  DEBUG = "debug",
  CLAIM_CLIENTS = "claim-clients",
  ERROR_TEST = "error-test",
  RESET = "reset",
  SPAM_LONG = "spam-long",
  SPAM_MANY = "spam-many",
}

type DebugMessage = {
  type: ClientToSWMessageType.DEBUG;
  namespaces: string;
};

type ClaimClientsMessage = {
  type: ClientToSWMessageType.CLAIM_CLIENTS;
};

type ErrorTestMessage = {
  type: ClientToSWMessageType.ERROR_TEST;
  error: string;
};

type ResetSwMessage = {
  type: ClientToSWMessageType.RESET;
};

type SpamLongToSWMessage = {
  type: ClientToSWMessageType.SPAM_LONG;
  modelVersion: string;
};

type SpamManyToSWMessage = {
  type: ClientToSWMessageType.SPAM_MANY;
  modelVersion: string;
  total: number;
  current: number;
};

export type ClientToSWMessage =
  | DebugMessage
  | ClaimClientsMessage
  | ErrorTestMessage
  | ResetSwMessage
  | SpamLongToSWMessage
  | SpamManyToSWMessage;
